import * as React from 'react';
import { connect } from 'react-redux';
import { BeatLoader } from 'react-spinners';
import { cognitoOAuth } from '../../../share/services/cognito-oauth';
import { loginActions } from '../store/actions';
import routes from '../../Routing/routes';

interface IOAuthCallbackProps {
    onCompleteLogin: (username: string, session: any) => any;
    history: any;
}

interface IOAuthCallbackState {
    error: string;
}

class OAuthCallback extends React.Component<IOAuthCallbackProps, IOAuthCallbackState> {
    constructor(props: IOAuthCallbackProps) {
        super(props);
        this.state = { error: '' };
    }

    public async componentDidMount(): Promise<void> {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const returnedState = params.get('state');

        if (!code) {
            this.props.history.replace('/login?error=oauth_failed');
            return;
        }

        // CSRF: the state returned by Cognito must match the value we stored before
        // redirecting. Validate before touching the code, and bail out if it doesn't.
        if (!cognitoOAuth.validateState(returnedState)) {
            this.setState({ error: 'Sign-in could not be verified (state mismatch). Please start again.' });
            return;
        }

        try {
            const tokens = await cognitoOAuth.exchangeCodeForTokens(code);
            const session = cognitoOAuth.buildSessionAdapter(tokens);
            const idPayload = session.getIdToken().decodePayload();
            const username = idPayload.email as string;
            await this.props.onCompleteLogin(username, session);
            // completeLogin established the redux session; this callback route owns
            // its navigation. Return the user to the page they originally wanted
            // (captured before the hosted-UI redirect), defaulting to HOME.
            const dest = cognitoOAuth.consumePostLoginRedirect();
            this.props.history.replace(dest || routes.HOME);
        } catch (err) {
            const message = (err && (err as any).message) || 'Sign-in failed';
            // tslint:disable-next-line:no-console
            console.error('[OAuthCallback] login failed:', err);
            this.setState({ error: message });
        }
    }

    public render(): React.ReactElement {
        const { error } = this.state;
        if (error) {
            return (
                <div style={{ textAlign: 'center', marginTop: '4rem' }}>
                    <p className="FormError">{error}</p>
                    <a href="/login">Back to login</a>
                </div>
            );
        }
        return (
            <div style={{ textAlign: 'center', marginTop: '4rem' }}>
                <BeatLoader loading={true} />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch: any) => ({
    onCompleteLogin: (username: string, session: any) =>
        dispatch(loginActions.completeLogin(username, session)),
});

export default connect(null, mapDispatchToProps)(OAuthCallback);
